export default __webpack_public_path__ + "static/media/infections@2x.73a0ab79.png";